import {
  ICareerCertificateValue,
  ICareerProjectValue,
  ICareerSkillValue,
  ILanguages,
  Languages,
} from 'context';
import { IEducationValues } from 'organisms/ResumeEducationCard/ResumeEducationCard';
import { IExperienceValues } from 'organisms/ResumeExperienceCard/ResumeExperienceCard';

/**
 * The full career-profile editor form model (spec 0018, increment B).
 *
 * Language-neutral facts (basics + collections) plus, since 0072, the
 * per-language CV headline / about text: one form, one «Zapisz zmiany», one
 * `saveCareerProfile` transaction.
 */
export interface ICvTextValue {
  jobTitle: string;
  about: string;
}

/** Языки, на которых студент пишет текст CV (как `CV_LANGUAGES` сервера). */
export const CV_TEXT_LANGUAGES: Languages[] = [Languages.polish, Languages.english];

export const emptyCvTexts = (): Record<string, ICvTextValue> =>
  Object.fromEntries(CV_TEXT_LANGUAGES.map((language) => [language, { jobTitle: '', about: '' }]));

export interface ICareerProfileFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  country: string;
  relocationReady: boolean;
  workMode: string;
  workPermit: string;
  availableFrom: string;
  seniority: string;
  desiredPosition: string;
  desiredSalary: string;
  githubUrl: string;
  linkedinUrl: string;
  portfolioUrl: string;
  skills: ICareerSkillValue[];
  customSkills: string[];
  projects: ICareerProjectValue[];
  experience: IExperienceValues[];
  education: IEducationValues[];
  languages: ILanguages[];
  certificates: ICareerCertificateValue[];
  /** Текст CV по языкам — ключ `Languages` (POL / ENG). */
  cvTexts: Record<string, ICvTextValue>;
}
